import isGenerator from "./is-generator";
import createRuntime from "./runtime";
function createMiddleware(controls = {}) {
  return (store) => {
    const runtime = createRuntime(controls, store.dispatch);
    return (next) => (action) => {
      if (!isGenerator(action)) {
        return next(action);
      }
      return runtime(action);
    };
  };
}
export {
  createMiddleware as default
};
//# sourceMappingURL=index.js.map
